import React, { useState } from "react";
import {
  Button,
  Spinner,
} from "react-bootstrap";
import { format } from "date-fns";
import LeadFormModal from "./LeadFormModal";
import NumberFormat from "react-number-format";
import axios from "axios";
import "../css/header.css";


export default function Header(
  { configJSON,
    FHA30,
    pricingAsOfDate
  }) {
  const imgCDNURL = process.env.REACT_APP_ABOUT203KLOAN_CDN_URL;
  const imgCDNURL1 = process.env.REACT_APP_MORTGAGES4VETERANS_CDN_URL;
  const baseName = process.env.REACT_APP_BASENAME;
  const noteRate = FHA30.rate;
  const aprRate = FHA30.aprEstimated;
  const fico = configJSON.fico;
  const loanPurposeKeyword = configJSON.loanPurposeKeyword;
  const loanAmount = configJSON.loanAmount;
  const propertyValue = configJSON.propertyValue;

  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const prepend_dollar = (num) => {
    return "$" + num.toLocaleString(undefined, { maximumFractionDigits: 2 });
  };

  const format_money = (num) => {
    return prepend_dollar(num);
  };

  let basePath = baseName;
  if (baseName === "/about203kloan") {
    basePath = basePath + "/";
  }

  const [showFormModal, setShowFormModal] = useState(false);
  const [loanPurposeKwd, setLoanPurposeKwd] = useState("");
  const [frmHeading, setFrmHeading] = useState("");
  const [offerTerm, setOfferTerm] = useState("");
  const [offerRate, setOfferRate] = useState("");

  const handlePurchaseModal = () => {
    setShowFormModal(true);
    setLoanPurposeKwd("PURCHASE REHAB");
    setFrmHeading("Apply For Purchase");
    document.body.classList.add('no-scroll');
  };

  const handleRefiModal = () => {
    setShowFormModal(true);
    setLoanPurposeKwd("REFI REHAB");
    setFrmHeading("Apply For Refinance");
    document.body.classList.add('no-scroll');
  };

  const handleApplyNowModal = () => {
    setShowFormModal(true);
    setLoanPurposeKwd("");
    setFrmHeading("Apply Now");
    document.body.classList.add('no-scroll');
  };

  const handleCallMeModal = () => {
    setShowFormModal(true);
    setLoanPurposeKwd("");
    setFrmHeading("Call Me");
    document.body.classList.add('no-scroll');
  };

  const handleRatesModal = () => {
    setShowFormModal(true);
    setLoanPurposeKwd("");
    setFrmHeading("Apply Now with Today's Rate");
    document.body.classList.add('no-scroll');
  };

  const doNothing = () => { };

  const handleCloseFormModal = () => {setShowFormModal(false);document.body.classList.remove('no-scroll');}

  const changeRateBoxColor = () => {
    document.getElementById("termYear").className = "termYearWhite text-center";
    document.getElementById("termYearBorder").className =
      "termYearBorderWhite text-center";
    if (document.getElementById("rateApr")) {
      document.getElementById("rateApr").className = "rateAprWhite text-center";
    } else {
      document.getElementById("fetchBestRate").className =
        "ps-2 fetchBestRateWhite";
    }
    document.getElementById("rateAprLegend").className =
      "pt-2 rateAprLegendWhite text-center";
  };

  const changeBackRateBoxColor = () => {
    document.getElementById("termYear").className = "termYear text-center";
    document.getElementById("termYearBorder").className =
      "termYearBorder text-center";
    if (document.getElementById("rateApr")) {
      document.getElementById("rateApr").className = "rateApr text-center";
    } else {
      document.getElementById("fetchBestRate").className = "ps-2 fetchBestRate";
    }
    document.getElementById("rateAprLegend").className =
      "pt-2 rateAprLegend text-center";
  };

  return (
    <>
      <div className="todaysRateContainer">
        <div className="todaysRateHeading mb-2">
          <h2>TODAY’S RATES</h2>
        </div>
        <img
          src={imgCDNURL + "mobile-ellipse-desktop-right.webp"}
          className="mobile-ellipse-desktop-right img-fluid"
          alt="mobile-ellipse-desktop-right"
        />
        <img
          src={imgCDNURL + "mobile-ellipse-desktop-left.webp"}
          className="mobile-ellipse-desktop-left img-fluid"
          alt="mobile-ellipse-desktop-left"
        />
        <div className="productHeading mb-2">
          <hr className="hrLine" />
          <div className="dotsCircle" />
          <div className="ps-2 pe-2">
            <h5>FHA 203K</h5>
          </div>
          <div className="dotsCircle" />
          <hr className="hrLine" />
        </div>
        <div className="ratesContainer mb-3">
          <div
            id="ratesPricingBox"
            className={
              noteRate
                ? "ratesPricingBox ratesPricingBoxCursor"
                : "ratesPricingBox"
            }
            onMouseOver={changeRateBoxColor}
            onMouseOut={changeBackRateBoxColor}
            onClick={noteRate ? handleRatesModal : doNothing}
          >
            <div id="termYear" className="termYear text-center">
              <h5>30 Year Fixed</h5>
            </div>
            <div id="termYearBorder" className="termYearBorder text-center">
              <hr />
            </div>
            {noteRate ? (
              <div id="rateApr" className="rateApr text-center">
                <h1>
                  <NumberFormat
                    value={noteRate}
                    displayType={"text"}
                    suffix={"%"}
                    decimalScale={3}
                    fixedDecimalScale={true}
                  />{" "}
                  /{" "}
                  <NumberFormat
                    value={aprRate}
                    displayType={"text"}
                    suffix={"%"}
                    decimalScale={3}
                    fixedDecimalScale={true}
                  />
                </h1>
              </div>
            ) : (
              <div className="d-flex justify-content-center">
                <Spinner animation="border" role="status" />
                <h6 id="fetchBestRate" className="ps-2 rateAprLegend">
                  Fetching Best Rates...
                </h6>
              </div>
            )}
            <div id="rateAprLegend" className="pt-2 rateAprLegend text-center">
              <h4>(Rate/APR)</h4>
            </div>
          </div>
        </div>
        <div className="purchaseRefinanceBtn mb-1">
          <div className="purchaseRefinanceBtnContainer mb-3">
            <Button
              variant="primary"
              className="d-flex headerBtn purchaseBtn"
              onClick={handlePurchaseModal}
            >
              Purchase <hr className="whiteLine" />{" "}
              <i className="arrowWhite right" />
            </Button>
          </div>
          <div className="purchaseRefinanceBtnContainer mb-3">
            <Button
              variant="primary"
              className="d-flex refinanceBtn"
              onClick={handleRefiModal}
            >
              Refinance <hr className="blueLine" />{" "}
              <i className="arrowBlue right" />
            </Button>
          </div>
        </div>
        <div className="text-center mb-3">
          <Button
            variant="primary"
            className="applyNowBtn"
            onClick={handleApplyNowModal}
          >
            Apply Now
          </Button>
        </div>

        {noteRate ? (
          <div className="ratesRequestDetails justify-content-center mb-5">

            <div
              id="loanScenarioDetails"
              className="loanScenarioDetails text-center"
            >
              <h6 className="loanScenarioText">{capitalizeFirstLetter(loanPurposeKeyword)} | {fico} FICO</h6>
              <h6 className="loanScenarioText">
                The rates above are based on a loan amount of {format_money(loanAmount)} with an
                appraised value of {format_money(propertyValue)}.
              </h6>
              <h6 className="loanScenarioText">
                Loans that do not meet these criteria may have a higher interest
                rate and Annual Percentage Rate (APR). Maximum loan amount may
                vary for your county.
              </h6>
              <h6 className="loanScenarioText">
                Rates are subject to change without notice. Not all applicants
                will qualify. Interest Rate and APR are estimates as of {pricingAsOfDate}.
              </h6>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>

      <div
        className="d-flex iLoveRateCallMeContainer"
        onClick={handleCallMeModal}
      >
        <div className="phoneIconContainer">
          <img
            src={imgCDNURL + "phone-icon.png"}
            className="phone-icon img-fluid"
            alt="call-me-icon"
          />
        </div>
        <div className="ps-2">
          <h5 className="iLoveRateCallMeText">I love the Rate. Call Me!</h5>
        </div>
      </div>

      <div className="blueBand"></div>

      <div>
        {showFormModal && (
          <LeadFormModal
            loanPurpKeyword={loanPurposeKwd}
            noteRate={noteRate}
            formHeading={frmHeading}
            showLeadFormModal={showFormModal}
            onHide={handleCloseFormModal}
          />
        )}
      </div>
    </>
  );
}
